class Select {
    constructor(element) {
        /**
         * @type {Element}
         */
        this.select = element.querySelector('select');

        // Add change listener
        this.select.addEventListener('change', () => this.change());

        // Set initial color
        if (this.select.value) {
            this.select.style.color = '#000';
        }
    }

    change() {
        if (this.select.value) {
            this.select.style.color = '#000';
        } else {
            this.select.style.color = '';
        }
    }
}